import { render, staticRenderFns } from "./TitleDetailStreamingChart.vue?vue&type=template&id=70cd0a8b&scoped=true"
import script from "./TitleDetailStreamingChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailStreamingChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailStreamingChart.vue?vue&type=style&index=0&id=70cd0a8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd0a8b",
  null
  
)

export default component.exports